// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileSvgSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm9 3.5a.5.5 0 0 0 .5.5h3.293a.5.5 0 0 0 .353-.854l-3.292-3.292a.5.5 0 0 0-.854.353zm2.195 5.756h.747c-.028.176-.06.26-.125.352-.135.167-.343.26-.594.26-.26 0-.469-.088-.617-.255-.2-.209-.316-.529-.316-.85 0-.626.385-1.094.905-1.094.353 0 .594.176.752.557l.863-.358c-.33-.672-.826-.983-1.573-.983-1.128 0-1.898.756-1.898 1.874 0 1.1.761 1.856 1.865 1.856.752 0 1.323-.352 1.61-.988.13-.279.177-.562.186-1.077h-1.805zM9.08 12.9l.362-.71a2.474 2.474 0 0 0-1.11-.283c-.705 0-1.187.478-1.187 1.179 0 .31.093.542.278.696.126.102.274.167.664.283.427.125.547.213.547.403 0 .204-.176.339-.44.339-.27 0-.52-.111-.803-.357l-.39.733c.371.26.798.394 1.211.394.404 0 .76-.116 1.011-.33.237-.203.358-.51.358-.904 0-.52-.25-.803-.859-.984-.408-.12-.445-.134-.547-.218a.237.237 0 0 1-.084-.176c0-.172.167-.302.39-.302.209 0 .394.074.599.237zm2.452 1.22-.836-2.13h-.992l1.466 3.499h.71l1.489-3.498h-.988z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileSvgSolid;
